// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteAccountUpsearchResponseModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteAccountUpsearchResponseModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.discriminator = undefined;
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.additionalProperties = false;
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.attributeTypeMap = [
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteAccountUpsearchResponseModel.js.map